var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', 'button--large', 'button--submit', 'button--full-width', { 'button--loading': _vm.loading } ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"button__spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f060936e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/submit/submit.vue
// module id = 1zuO
// module chunks = 0